// mui
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import Button from '@material-ui/core/Button'
// react
import { useState, useCallback, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { orderProduct } from '../reducks/products/operations'
import { retrievePaymentMethod } from '../reducks/users/operations'
import { getProductsInCart, getUserId, getPaymentMethodId } from '../reducks/users/selectors'
import styled from 'styled-components'
// fireabase
import { db } from '../firebase'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
// component
import { TextDetail, PrimaryButton, CartListItem, Layout } from '../components'

const stripePromise = loadStripe('pk_test_51HjV1UETSg2g6rumokJ3bypsRTC9jK8HDnmIXB5Vb4iFyC2PcCnGPUp5hHFI1lUgaHdW6im4ICflTZDecRWFjQ9500PxdQ2Q8n');

const OrderConfirm = () => {
    const dispatch = useDispatch()
    const selector = useSelector(state => state)
    const productsInCart = getProductsInCart(selector)
    const userId = getUserId(selector)

    const [user, setUser] = useState({})

    const paymentMethodId = getPaymentMethodId(selector)
    const [card, setCard] = useState({})
    

    // 小計計算
    const subtotal = useMemo(() => {
        return productsInCart.reduce((sum,product) => sum += Math.round(product.price * (100 - product.discount) / 100) * product.quantity, 0)
    }, [productsInCart])

    // 送料計算
    const shippingFee = ( subtotal >= 10000 ? 0 : 500 )

    // 合計金額計算
    const total = subtotal + shippingFee

    const order = useCallback( () => {
        dispatch(orderProduct(productsInCart, total, user, shippingFee))
    }, [productsInCart, total, user, shippingFee, dispatch])

    // カードブランド取得
    const cardBrand = useMemo(() => {
        if (card.brand) {
            return card.brand
        } else {
            return '----'
        }
    }, [card])
    // カード番号下4桁取得
    const cardNumber = useMemo(() => {
        if (card.last4) {
            return "**** **** **** " + card.last4
        } else {
            return '未登録'
        }
    }, [card])
    // カード情報取得
    useEffect(() => {
        (async () => {
            const cardData = await retrievePaymentMethod(paymentMethodId)
            if (cardData) { setCard(cardData) }
        })()
    },[paymentMethodId])

    // ユーザー情報取得
    useEffect(()=>{
        if(userId) {
            db.collection('users').doc(userId).get()
              .then(snapshot => {
                  const data = snapshot.data()
                  setUser(data)
              })
        }
    },[userId])
    
    return (
        <Layout>
            <div className='spacer-100' />
            <h1 style={{textAlign:'center'}}>注文の確認</h1>
            <div className='spacer-50' />

            <Wrapper>
                <div className='spacer-50' />
                <SubHeading>お届け先情報</SubHeading>
                <CustomerInfo>
                    <TextDetail label='お届け先住所' value={'〒' + user.postalCode + " " + user.prefecture + user.city + user.street} />
                    <TextDetail label='お届け先氏名' value={user.lastname + " " + user.firstname} />
                    <div style={{textAlign:'right'}}>
                        <Button color={'primary'} onClick={()=>dispatch(push('/profile/edit'))}>変更する</Button>
                    </div>
                </CustomerInfo>

                <div className='spacer-100' />

                <SubHeading>お支払い方法</SubHeading>
                <CustomerInfo>
                    <Elements stripe={stripePromise} >
                        <TextDetail label={`クレジットカード（${cardBrand.toUpperCase()}）`} value={cardNumber} />
                    </Elements>
                    <div style={{textAlign:'right'}}>
                        <Button color={'primary'} onClick={()=>dispatch(push('/payment/edit'))}>変更する</Button>
                    </div>
                </CustomerInfo>

                <div className='spacer-100' />

                <SubHeading>カート内の商品</SubHeading>
                <List>
                    {productsInCart.length > 0 && (
                        productsInCart.map(product => <CartListItem key={product.cartId} product={product} fixed={true}/>)
                    )}
                </List>
                <ProductInfo>
                    <div style={{textAlign:'right'}}>
                        <Button color={'primary'} onClick={()=>dispatch(push('/cart'))}>変更する</Button>
                    </div>
                </ProductInfo>

                <div className='spacer-50' />

                <div className='spacer-50' />
                <SubHeading>請求情報</SubHeading>
                <InvoiceInfo>
                    <div className='spacer-50' />
                    <TextDetail label='小計' value={'¥' + subtotal.toLocaleString()} />
                    <TextDetail label='送料' value={'¥' + shippingFee.toLocaleString()} />
                    <Divider />
                    <TextDetail label='合計' value={'¥' + total.toLocaleString()} />
                    <div className='spacer-50' />
                </InvoiceInfo>

                <div style={{textAlign: 'center'}}>
                    <PrimaryButton label='注文を確定する' operation={order} />
                    <div className='spacer-25' />
                    <Button onClick={()=>dispatch(push('/'))}>ホームへ戻る</Button>
                </div>
                <div className='spacer-100' />

            </Wrapper>
        </Layout>
    )
}
export default OrderConfirm

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 640px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`
const SubHeading = styled.h4`
    font-size: 24px !important;
    margin-bottom: 24px;
`
const CustomerInfo = styled.div`
    width: 640px;
    padding: 8px 16px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
    }
`
const ProductInfo = styled.div`
    padding: 8px 16px;
`
const InvoiceInfo = styled.div`
    width: 320px;
    margin: 0 auto;
`